// Hero toggle description
$(document).ready(function () {
    var dots = "... ";
    var moreText = "Vedi altro";
    var lessText = "Vedi meno";

    var showCharIntro = 410;
    $('.collapsible').each(function () {
		if (this.scrollHeight <= this.clientHeight) {
			$(this).siblings('.morelink').remove();
		}
    });

    $(".morelink").click(function (e) {
		e.preventDefault();

        if ($(this).hasClass("test")) {
            $(this).removeClass("test");
            $(this).siblings('.collapsible').get(0).style.setProperty("--clamped-lines", 2);
			$(this).text(moreText);
        }
		else {
            $(this).addClass("test");
            $(this).siblings('.collapsible').get(0).style.setProperty("--clamped-lines", 100);
			$(this).text(lessText);
        }
    });

    var text = $(".text-limit").text();
    var len = text.length;

    if(len > 237){
    	$(".text-limit").text($(".text-limit").text().substr(0,236)+'...  ');
    }
});
